import { render } from "./reportbin.vue?vue&type=template&id=5809424e&scoped=true"
import script from "./reportbin.vue?vue&type=script&lang=js"
export * from "./reportbin.vue?vue&type=script&lang=js"

import "./reportbin.vue?vue&type=style&index=0&id=5809424e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5809424e"]])

export default __exports__